import React from "react";
import { createRoot } from "react-dom/client";
import BrowseArtistFilter from "./BrowseArtistFilter";
import BrowseArtistFilter2 from "./BrowseArtistFilter2";

if (document.getElementById("sifa-artist-filter")) {
    const root = createRoot(document.getElementById("sifa-artist-filter"));
    const filterURL = JSON.parse(document.getElementById("sifa-artist-filter").dataset.url);
    const APIEndpoint = JSON.parse(document.getElementById("sifa-artist-filter").dataset.api);
    root.render(
        <BrowseArtistFilter
            filter_url={filterURL}
            api_endpoint={APIEndpoint}
        />
    );
}

const filterElement2 = document.getElementById("sifa-artist-filter-2");
if (filterElement2) {
    const root = createRoot(filterElement2);
    const filterURL = JSON.parse(filterElement2.dataset.url);
    const APIEndpoint = JSON.parse(filterElement2.dataset.api);
    const title = filterElement2.dataset.title;
    root.render(
        <BrowseArtistFilter2
            filter_url={filterURL}
            api_endpoint={APIEndpoint}
            title={title}
        />
    );
}
